<template>
  <div class="lamp-content">
    <el-form label-postion="left" label-width="140px">
      <el-form-item label="策略名称">
        <el-input
          placeholder="请输入策略名"
          v-model="editOne.title"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否提前" prop="is_advance">
        <el-radio-group v-model="editOne.is_advance">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="操作类型" prop="is_advance_type" v-if="editOne.is_advance">
        <el-radio-group v-model="editOne.is_advance_type">
          <el-radio :label="1">开灯</el-radio>
          <el-radio :label="0">关灯</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="提前时间（分钟）" prop="advance_minute" v-if="editOne.is_advance">
        <el-input-number v-model="editOne.advance_minute" :min="1" :max="30" class="my_number"></el-input-number>
      </el-form-item>
      <div style="border-bottom:1px solid #dfdfdf;margin-bottom:10px;"></div>
      <el-form-item label="是否延迟" prop="is_delay">
        <el-radio-group v-model="editOne.is_delay">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="操作类型" prop="is_delay_type" v-if="editOne.is_delay">
        <el-radio-group v-model="editOne.is_delay_type">
          <el-radio :label="1">开灯</el-radio>
          <el-radio :label="0">关灯</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="延迟时间（分钟）" prop="delay_minute" v-if="editOne.is_delay">
        <el-input-number v-model="editOne.delay_minute" :min="1" :max="30" class="my_number"></el-input-number>
      </el-form-item>
      <hr />
      <el-form-item
        label="时间段"
        v-for="(item, index) in editOne.content"
        :key="item.key"
        :class="{
          crossed: item.crossed,
        }"
      >
        <el-row :gutter="20" class="item-list">
          <el-col :span="7">
            <el-slider
              range
              v-model="item.timeslots"
              :min="0"
              :max="86399"
              :step="900"
              @change="updateTime(item)"
              :format-tooltip="numberToTimeString"
            >
            </el-slider>
          </el-col>
          <el-col :span="4">
            <el-time-picker
              is-range
              arrow-control
              v-model="item.timeslotsObj"
              @change="updateTimeNumber(item)"
              format="HH:mm"
              style="width: 100%"
            >
            </el-time-picker>
          </el-col>
          <el-col :span="5">
            <span class="mar-r10">关</span>
            <el-switch
              v-model="item.light"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
            />
            <span class="mar-l10">开</span>
          </el-col>

          <el-col :span="2">
            <el-button class="remove" type="danger" @click="removeTime(index)"
              >删除</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addTime">新建时间段</el-button>
      </el-form-item>
      <hr />
      <el-button
        type="primary"
        native-type="submit"
        @click.prevent="addStrategy"
        >保存</el-button
      >
      <el-button type="error" @click="cancel">取消</el-button>
    </el-form>
  </div>
</template>
<script>
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/light/strategy";
export default {
  name: "addStrategy",
  data() {
    return {
      crossed: false,
      editOne: {
        title: "",
        is_advance: 0,
        is_advance_type: 0,
        advance_minute: 0,
        is_delay: 0,
        delay_minute: 0,
        is_delay_type: 0,
        content: [],
      },
    };
  },
  methods: {
    ...time,
    updateTimeNumber(item) {
      this.checkValid();
      item.timeslots = [
        this.timeToNumber(item.timeslotsObj[0]),
        this.timeToNumber(item.timeslotsObj[1]),
      ];
    },
    updateTime(item) {
      this.checkValid();
      item.timeslotsObj = [
        this.numberToTime(item.timeslots[0]),
        this.numberToTime(item.timeslots[1]),
      ];
    },
    removeTime(index) {
      if (confirm("确定要删除这个时间段？")) {
        this.editOne.content.splice(index, 1);
        this.checkValid();
      }
    },
    addStrategy() {
      let params = {
        title: this.editOne.title,
        is_advance: this.editOne.is_advance,
        is_advance_type: this.editOne.is_advance_type,
        advance_minute: this.editOne.advance_minute,
        is_delay: this.editOne.is_delay,
        delay_minute: this.editOne.delay_minute,
        is_delay_type: this.editOne.is_delay_type,
        time: "",
        light: ""
      }
      let status = "";
      let slight = "";
      this.editOne.content
        .sort((x, y) => x.timeslotsObj[0] > y.timeslotsObj[0])
        .forEach((item, index) => {
          status +=
            [
              moment(item.timeslotsObj[0]).format("HH:mm") +
                "-" +
                moment(item.timeslotsObj[1]).format("HH:mm"),
            ] + ",";
          slight += item.light + ",";
        });
      params.time = status.substring(0, status.length - 1);
      params.light = slight.substring(0, slight.length - 1);
      if (params.time === "") {
        this.$message.error("请新建时间段");
      } else {
        if (this.crossed) {
          this.$message.error("请不要选择重复时间段");
        } else {
          strategyApi.foucusStrategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.$emit('closeMethod')
            } else {
              this.$message.error(res.data.message);
            }
          })
        }
      }
    },
    addTime() {
      this.editOne.content.push({
        key: Date.now(),
        light: 1,
        timeslots: [0, 3600],
        timeslotsObj: [this.numberToTime(0), this.numberToTime(3600)],
      });
      this.checkValid();
    },
    checkValid(change) {
      this.crossed = false;
      const cross = (s1, s2) => {
        return s2.timeslots[0] <= s1.timeslots[1];
      };
      for (let i = 0; i < this.editOne.content.length; i++) {
        for (let j = i + 1; j < this.editOne.content.length; j++) {
          const s1 = this.editOne.content[i];
          const s2 = this.editOne.content[j];
          if (s1.timeslots[0] <= s2.timeslots[0]) {
            this.crossed = cross(s1, s2);
          } else {
            this.crossed = cross(s2, s1);
          }
          if (this.crossed) {
            s1.crossed = true;
            s2.crossed = true;
            return;
          } else {
            s1.crossed = false;
            s2.crossed = false;
          }
        }
      }
    },
    cancel() {
      this.$emit('closeMethod')
    }
  }
}
</script>

<style lang='less'>
.my_number {
  width: 120px;
  .el-input__inner{
    height:28px !important;
    line-height:28px !important;
  }
}
.crossed .el-form-item__label,
.crossed .el-date-editor input,
.crossed .el-date-editor .el-input__icon {
  color: #ff4949 !important;
}
.crossed .el-slider__button,
.crossed .el-slider__bar {
  background: #ff4949 !important;
}
.crossed .el-slider__runway {
  background: #ffcdd2 !important;
}
.crossed .el-date-editor input {
  border-color: #ff4949 !important;
}
</style>